import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "smReaction",
    standalone: false
})
export class ReactionPipe implements PipeTransform {
  transform(value: string): unknown {
    //'Like','Love','Happy','Funny','Wow
    switch (value.toLowerCase()) {
      case "like":
        return "thumbs-up";

      case "love":
        return "heart";

      case "happy":
        return "smile";

      case "funny":
        return "grin-squint-tears";

      case "wow":
        return "surprise";

      default:
        break;
    }

    return null;
  }
}
